import { Component, effect, OnInit, signal, Signal, ViewChild, AfterViewInit } from "@angular/core"; import { Location } from "@angular/common";
import { Table, TableFilterEvent } from 'primeng/table';
import { MessageService, ConfirmationService, FilterService } from 'primeng/api';
import { NonConformiteSimpleEntite } from '../../entites/non-conformite-simple';
import { NonConformiteService } from '../../services/non-conformite-service';
import { BaseComponent } from '../../base/base-component';
import { DonneesBaseService } from '../../services/donnees-base-service';
import { ProfilService } from '../../services/profil-service';
import { ActivatedRoute } from '@angular/router';
import { AppMainComponent } from '../../app.main.component';
import { Router } from '@angular/router';
import { BreadcrumbService } from '../../app.breadcrumb.service';
import { Statut } from '../../entites/statut';
import { DialogService } from 'primeng/dynamicdialog';
import { AjoutNonConformiteComponent } from './ajout-non-conformite.component';
import { MenuItem } from 'primeng/api';
import { RapportService } from "src/app/services/rapport-service";
import { EStatuts } from "src/app/entites/enums/statuts";

@Component({
  selector: 'app-non-conformite',
  styleUrls: ['./non-conformite.component.scss'],
  templateUrl: './non-conformite.component.html',
  providers: [MessageService, ConfirmationService, NonConformiteService, DialogService],
})
export class NonConformiteComponent extends BaseComponent implements OnInit, AfterViewInit {
  nonConformites: NonConformiteSimpleEntite[];
  nonConformitesFiltrees: NonConformiteSimpleEntite[];
  selectedNonConformites: NonConformiteSimpleEntite[];
  nonConformite: NonConformiteSimpleEntite;
  nonConformiteDialog: boolean;
  statuses: any[];
  contenuMenuContextuelNonConformite: any[];
  menuContextuelNonConformite: MenuItem;
  showMine: any = this.createParamSignal('showMine', 'false');
  tableFilter: any;
  tableParams = this.createTableFilter();
  @ViewChild('dt') table: Table;
  globalFilter: string = '';
  statuts: Statut[] = this.sdb.Statuts().filter(x => x.statutId == EStatuts.Nouveau || x.statutId == EStatuts.Traite || x.statutId == EStatuts.Archive);

  constructor(
    sdb: DonneesBaseService,
    profilService: ProfilService,
    route: ActivatedRoute, 
		appMain: AppMainComponent, location: Location, 
    private nonConformiteService: NonConformiteService,
    private messageService: MessageService,
    private breadcrumbService: BreadcrumbService,
    public routerService: Router,
    public dialogService: DialogService,
    private filterService: FilterService,
    private rapportService: RapportService
  ) {super(sdb, profilService, route, routerService, appMain)
    this.breadcrumbService.setItems([
      { label: 'Non-conformités' }
    ]);
  }

  ngOnInit() {
    this.colonnesDisponibles = [
      {base: true, entete: 'Numéro', champ: 'numero', afficheParDefaut: true},
      {base: true, entete: 'Titre', champ: 'titre', afficheParDefaut: true},
      {base: true, entete: 'Code Projet', champ: 'codeProjet', afficheParDefaut: true},
      {base: true, entete: 'Statut', champ: 'statut', afficheParDefaut: true},
      {base: true, entete: 'Date d\'emission', champ: 'dateEmission', afficheParDefaut: true},
      {base: true, entete: 'Date de détection', champ: 'dateDetection', afficheParDefaut: true},
      {base: true, entete: 'Catégorie', champ: 'type', afficheParDefaut: true},
      {base: true, entete: 'Objet', champ: 'objet', afficheParDefaut: true},
      {base: true, entete: 'Employé', champ: 'employe', afficheParDefaut: true},
      {base: true, entete: 'Approbation', champ: 'approbation', afficheParDefaut: true},
      {base: true, entete: 'Monétaire', champ: 'monetaire', afficheParDefaut: true},
      {base: true, entete: 'Messages', champ: 'nbMessages', afficheParDefaut: false},
      {base: true, entete: 'Dernier message', champ: 'dateDernierMessage', afficheParDefaut: false},
    ];
    this.colonnesSelectionnees = this.colonnesDisponibles.filter(colonne => colonne.afficheParDefaut);
    this.loadNonConformites();

    this.filterService.register('employe', (value, filter) => {
      if (filter === '') {
        return true;
      }
      return value?.employeId == filter;
    });
  }

  ngAfterViewInit() {
    this.globalFilter = this.tableParams.getValue().globalFilter;
    this.chargerColonnesSelectionnees();
  }

  loadNonConformites() {
    this.nonConformiteService.Obtenir().then(
      (data) => {
        this.nonConformites = data.valeur;

        this.filterNonConformites();

        this.CompleterChargement();
      },
      (error) => {
        this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Erreur lors du chargement des non-conformités' });
      }
    );
  }

  hideDialog() {
    this.nonConformiteDialog = false;
  }

  clearFilters(table: Table) {
    table.reset();
    table.clear();
    this.globalFilter = '';
    this.tableParams.setValue(table);
}

  surChangementColonnes(event) {
    this.colonnesSelectionnees = event.value;
  }

  newNonConformite() {
    this.dialogService.open(AjoutNonConformiteComponent, {
      header: 'Nouveau rapport de Non-conformité',
      width: '90%'
    }).onClose.subscribe((nonConformite: NonConformiteSimpleEntite) => {
        if (nonConformite) {
          this.routerService.navigateByUrl('assurancequalite/nonconformite/' + nonConformite.idNonConformite);
        } else {
          this.breadcrumbService.setItems([
            { label: 'Non-conformités' }
          ]);
          this.routerService.navigateByUrl('assurancequalite/nonconformite');
        }
    });
  }

  openNonConformite(idNonConformite: number) {
    this.routerService.navigateByUrl('assurancequalite/nonconformite/' + idNonConformite);
  }

  openActionCorrective(nonConformite: NonConformiteSimpleEntite) {
    this.routerService.navigateByUrl('assurancequalite/actioncorrective/' + nonConformite.actionCorrectiveId);
  }

  produireRapportCompilationNonConformite() {
    this.messageService.add({ severity: 'info', summary: 'Info', detail: 'Production du rapport en cours...' });
    this.rapportService.ProduireRapportCompilationNonConformite().then(x => {
      if (x) {
        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Rapport produit avec succès' });
      } else {
        this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Erreur lors de la production du rapport' });
      }
    });
  }

  filterNonConformites() {
    if (this.showMine() === 'true') {
      this.nonConformitesFiltrees = this.nonConformites.filter(x => x.employe.employeId == this.profilService.ProfilCourant().employeId);
    } else {
      this.nonConformitesFiltrees = this.nonConformites;
    }
  }


}